import { createContext } from "react";

export const AdminSiteContext = createContext(null);
